export const BUILD_TIME_EPO_FORWARD_REDIRECT_ENABLED = true;

/**
 * Feature flag for the legacy `#/epo/*` forward redirect to EPO's own app. Resolved at boot from the
 * build-time flag OR the `epoForwardRedirect` debug toggle. A persisted debug store from before this key
 * existed reads `undefined`, which is off.
 */
export const isEpoForwardRedirectEnabled = (debugPanelEpoForwardRedirect: boolean): boolean =>
  BUILD_TIME_EPO_FORWARD_REDIRECT_ENABLED || debugPanelEpoForwardRedirect;
